import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";

export interface LookupVIewDto {
    id: string;
    typeId: string;
    groupId?: string | undefined;
    code?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    enumName?: string | undefined;
    sortValue: number;
    isLocked: boolean;
    isDefaultValue: boolean;
    recordVersion: string;
}

export class LookupDto {
    public id: string;
    public parentId: string;
    public groupId: string | undefined;
    public code: string | undefined;
    public display: string | undefined;
    public description: string | undefined;
    public sortValue: number | undefined;
    public isDefault: boolean;
    public isActive: boolean | undefined;

    constructor(
        id: string,
        parentId: string,
        groupId: string | undefined,
        code: string | undefined,
        display: string | undefined,
        description: string | undefined,
        sortValue: number | undefined,
        isDefault: boolean,
        isActive: boolean | undefined
    ) {
        this.id = id;
        this.parentId = parentId;
        this.groupId = groupId;
        this.code = code;
        this.display = display;
        this.description = description;
        this.sortValue = sortValue;
        this.isDefault = isDefault;
        this.isActive = isActive;
    }

    static mapToOptions = (lookups: LookupDto[] | null | undefined, excludeOptions?: string[] | undefined, opts?: { labelKey?: "display" | "code" }): DropdownOption[] => {
        if (!Array.isArray(lookups) || lookups.length === 0) {
            return [];
        }

        if (excludeOptions) {
            lookups = lookups.filter(x => excludeOptions.findIndex(y => y.toLowerCase() === x.id.toLowerCase()) === -1);
        }

        const labelKey = opts?.labelKey ?? "display";

        return lookups.map((lookup) => {
            const label =
                labelKey === "code"
                    ? (lookup.code ?? lookup.display ?? "")
                    : (lookup.display ?? lookup.code ?? "");

            return {
                key: lookup.id as string,
                value: lookup.id as string,
                display: label,
            };
        });
    };

    static getLookupById = ( lookups: LookupDto[] | null | undefined, id: string | undefined ): LookupDto | undefined => {
        if (!Array.isArray(lookups) || lookups.length === 0 || id === undefined) {
            return undefined;
        }

        return lookups.find((x) => x.id === id);
    };
}
